(() => {
  'use strict';

  const STORAGE_KEY = 'jr:lastLeadForm';
  const BOUND = 'jrFormBound';

  const shadowRoots = () => {
    const roots = [document];
    const visit = (root) => {
      root.querySelectorAll('*').forEach((node) => {
        if (node.shadowRoot && !roots.includes(node.shadowRoot)) {
          roots.push(node.shadowRoot);
          visit(node.shadowRoot);
        }
      });
    };
    visit(document);
    return roots;
  };

  const all = (selector) => shadowRoots().flatMap((root) => Array.from(root.querySelectorAll(selector)));

  const findById = (id) => {
    if (!id) return null;
    for (const root of shadowRoots()) {
      const node = root.getElementById ? root.getElementById(id) : root.querySelector(`#${id.replace(/([ #;?%&,.+*~\\':"!^$[\]()=>|/@])/g, '\\$1')}`);
      if (node) return node;
    }
    return null;
  };

  const installShadowStyles = () => {
    const source = document.querySelector('link[href*="jr-form-system.css"]');
    if (!source) return;
    shadowRoots().forEach((root) => {
      if (root === document || root.querySelector('link[data-jr-form-styles]')) return;
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = source.href;
      link.dataset.jrFormStyles = 'true';
      root.prepend(link);
    });
  };

  const readMarker = () => {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const value = JSON.parse(raw);
      if (!value || Date.now() - Number(value.time || 0) > 15 * 60 * 1000) {
        sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return value;
    } catch (_) {
      return null;
    }
  };

  const saveMarker = (form) => {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        id: form.id || '',
        path: window.location.pathname,
        time: Date.now()
      }));
    } catch (_) {}
  };

  const setSubmitting = (form) => {
    if (form.classList.contains('is-submitting')) return;
    form.classList.add('is-submitting');
    form.setAttribute('aria-busy', 'true');
    form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach((button) => {
      button.disabled = true;
      if (button.tagName === 'INPUT') {
        button.dataset.jrOriginalValue = button.value;
        button.value = 'Sending…';
        return;
      }
      button.dataset.jrOriginalHtml = button.innerHTML;
      const label = button.querySelector('span');
      if (label && label.children.length === 0) label.textContent = 'Sending…';
      else button.textContent = 'Sending…';
    });
  };

  const nativeSubmit = (form) => HTMLFormElement.prototype.submit.call(form);

  const submitNewsletterBridge = async (form) => {
    const bridgeId = form.dataset.jrNewsletterBridge;
    const optIn = form.querySelector('[data-jr-newsletter-optin]');
    const sourceEmail = form.querySelector('[data-jr-newsletter-source]');
    if (!bridgeId || !optIn?.checked || !sourceEmail?.value) return;

    const bridge = findById(bridgeId);
    if (!bridge) return;
    const targetEmail = bridge.querySelector('[data-jr-newsletter-email]');
    if (!targetEmail) return;
    targetEmail.value = sourceEmail.value.trim();

    const action = (bridge.getAttribute('action') || '/contact').split('#')[0];
    const controller = 'AbortController' in window ? new AbortController() : null;
    const timeout = controller ? window.setTimeout(() => controller.abort(), 2500) : null;
    try {
      await fetch(action, {
        method: 'POST',
        body: new FormData(bridge),
        credentials: 'same-origin',
        keepalive: true,
        signal: controller?.signal
      });
    } catch (_) {
      // The lead form still submits so Jasjeet receives the request even if newsletter enrollment is unavailable.
    } finally {
      if (timeout) window.clearTimeout(timeout);
    }
  };

  const bindForm = (form) => {
    if (form.dataset[BOUND] === 'true') return;
    form.dataset[BOUND] = 'true';
    form.addEventListener('submit', async (event) => {
      if (!form.checkValidity()) return;
      saveMarker(form);

      if (form.dataset.jrNewsletterBridge && form.dataset.jrBridgeComplete !== 'true') {
        event.preventDefault();
        setSubmitting(form);
        await submitNewsletterBridge(form);
        form.dataset.jrBridgeComplete = 'true';
        nativeSubmit(form);
        return;
      }

      window.setTimeout(() => setSubmitting(form), 0);
    });
  };

  const bindAllForms = () => {
    installShadowStyles();
    all('form[data-jr-lead-form]').forEach(bindForm);
  };

  const focusFeedback = () => {
    const marker = readMarker();
    const successes = all('[data-jr-form-feedback="success"]');
    const errors = all('[data-jr-form-feedback="error"]');
    let target = null;

    if (marker && marker.path === window.location.pathname && marker.id) {
      target = successes.find((item) => item.closest('form')?.id === marker.id || item.id === `${marker.id}-success`) || null;
      if (successes.length > 1 && target) successes.forEach((item) => { item.hidden = item !== target; });
    }

    target = target || successes.find((item) => !item.hidden) || errors[0] || null;
    if (!target) return;

    window.setTimeout(() => {
      try { target.focus({ preventScroll: true }); } catch (_) { target.focus(); }
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 160);

    if (successes.includes(target)) {
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (_) {}
    }
  };

  const initialize = () => {
    bindAllForms();
    focusFeedback();
    const observer = new MutationObserver(() => bindAllForms());
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 8000);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
/* CRM bridge: mirrors every lead form into Make -> BoldTrail */ (function(){var W='https://hook.us2.make.com/x3urn3j3abclv4wyx4amw75a7tejid3g';var V=function(f,n){var e=f.querySelector('[name='+JSON.stringify(n)+']');if(!e)return '';if(e.type==='checkbox')return e.checked?'Yes':'No';return (e.value||'').trim();};document.addEventListener('submit',function(ev){try{var f=ev.target;if(!f||!f.matches||!f.matches('form[data-jr-lead-form]'))return;var em=V(f,'contact[email]');if(!em)return;var p=V(f,'contact[name]').split(' ').filter(Boolean);var c=V(f,'contact[Consent]');var d={first_name:p[0]||'',last_name:p.slice(1).join(' '),email:em,phone:V(f,'contact[phone]'),deal_type:'buyer',stage:f.dataset.jrLeadForm||'website',source:'Website - '+(f.dataset.jrLeadForm||'form'),lead_type:V(f,'contact[Request type]')||f.getAttribute('data-jrx-event')||'',page:location.pathname+location.search,page_title:document.title,message:[V(f,'contact[Search criteria]'),V(f,'contact[Search URL]'),V(f,'contact[Alert frequency]'),V(f,'contact[message]')].filter(Boolean).join(' | '),email_consent:c,sms_consent:c,submitted_at:new Date().toISOString()};var b=JSON.stringify(d);if(navigator.sendBeacon){navigator.sendBeacon(W,new Blob([b],{type:'application/json'}));return;}fetch(W,{method:'POST',body:b,headers:{'Content-Type':'application/json'},keepalive:true,mode:'no-cors'}).catch(function(){});}catch(_){}},true);})();